export default "__VITE_ASSET__d39a1a6e__"